<template>
    <div class="animated fadeIn delay-0.5s">

    <!-- <div id="Loading">
        <div class="loader-inner ball-beat">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div> -->

  <div class = 'container'>
     <div class="content-container-large">
            <img src="https://miro.medium.com/max/1400/1*rCot5fLOyaAEfuMV6ybvZw.png" width='100%' class='large-img'>
    </div>
    <div class="first-page">
        <div class="content-container-title">
            <div class="parent">
                <div class = "left">
                    <div class="paragraph">
                        <!-- <h1>A-Watch</br>Child Asthma Management Toolkit</h1> -->
                        <h1>Harmonica</h1>
                        <h6>Enhanced audio experience with ambient awareness</h6>
                        <p>
                            Harmonica is our Launch Project at Global Innovation Exchange(GIX), University of Washington. 
                        </p>    
                        <p>
                            During the past 6 months, my teammates and I partnered with Harman, worked on the next-gen active noise-canceling(ANC) headsets. 
                        </p>
                        <p>
                            We designed and built 3 machine learning-powered features for JBL headsets to achieve a seamless audio experience. 
                        </p>
                    </div>
                    <div class="info">
                        <div class = "left-left">
                        <h3>TIMELINE</h3>
                        <h3>TEAM</h3>
                        <h3> &nbsp</h3>
                        <h3> &nbsp</h3>
                        <h3> SPONSOR</h3>
                        <h3>IMPACT</h3>
                        </div>
                        <div class= "left-right">
                            <p>Jul - Dec 2019, 6 Months<br>
                            <a style="text-decoration: none; color: rgb(0, 0, 0);border-bottom:1px dashed rgb(160, 160, 160);" href="https://github.com/Cutuy" target="blank">
                            Chenyu Cui</a> | Software Engineer,<br>
                            <a style="text-decoration: none; color: rgb(0, 0, 0);border-bottom:1px dashed rgb(160, 160, 160);" href="https://github.com/chemwolf6922" target="blank">
                            Feng Wang</a> | Software Engineer,<br>
                            Mike Pan | Machine Learning Engineer,<br>
                            JBL Lifestyle Division, HARMAN International<br>
                            Prototypes and software handed over to Harman, under implementation
                            </p>
                        </div>
                    </div>
                    <div class=paragraph>
                            <!-- <p>
                            <a style="text-decoration: none;color: rgb(0, 0, 0);border-bottom:1px dashed rgb(160, 160, 160);" href="https://medium.com/@sixuanli/harmonica-92a53d343515" target="blank">
                            Read Full Case Study
                            </a>
                            </p> -->
                            <div class='button' onclick="window.open('https://medium.com/@sixuanli/harmonica-92a53d343515','_blank')" target="blank">Read Full Case Study</div>
                    </div>
                </div>
                <div class = "right">
                    <div class="paragraph">
                        <h2>My role</h2>
                            <p>
                                Product Manager<br>
                                UX Designer<br>
                            </p>
                        <h2>Skills</h2>
                            <p>
                                Feature Define<br>
                                User Research<br>
                                GTM Strategy
                            </p>
                        <h2>Deliverables</h2>
                            <p> 
                                Functional Demo<br>
                                Onboarding UX<br>
                                Feature Specs<br>
                                6-Month Launch Plan<br>
                            </p> 
                        <h2>Methods</h2>
                        <p>
                        Survey<br>
                        Interview<br>
                        Affinity Diagram<br>
                        Storyboard<br>
                        Diary Study<br>
                        Behavioral Prototype<br>
                        Wizard of Oz
                        </p>
                    </div>
                </div>
            </div>
            <p class="video">
            <iframe width="100%" height="480" src="https://www.youtube.com/embed/6ToJ2ZyJbrQ" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </p>
        </div>
    </div>
    <div class="light-page">
        <div class="content-container">
            <div class="title">
                <div class = "title-color2"> </div>
                <div class="title-text">
                    <h4>OVERVIEW</h4>
                    <h5>&nbsp</h5>
                </div>
            </div>
            <div class="paragraph">
                <h4>PROBLEM</h4>
                <blockquote>
                    Block all sounds including what we care about, or take off headphones and face the noisy outsides?
                </blockquote>
            </div>
            <div class="paragraph">
                <h4>Headphones bring temporary hearing disability</h4>
                <p>
                    When we enjoy music with headphones to relax or focus, we block all sounds including what we care about, which causes safety & social issues.
                </p>
                <!-- <p>
                    Or we’ll need to take off headphones and face noisy outsides frequently when we do need to interact with surroundings.
                </p> -->
            </div>
            <div class="paragraph">
                <div class='image-middle-container'>
                    <img src="https://miro.medium.com/max/1400/1*bJcnbKVgP6hqoMKed5xnJQ.png" width="70%">
                </div>
            </div>
            <div class="paragraph">
                <h4>PROPOSAL</h4>
                <blockquote>
                    Headphones that you never need to take off
                </blockquote>
                <h4>Ideal headphones would be Always-on, Instant-away</h4>
                <p>
                    <b>Always-on</b> People can wear headphones in any situation, all day long, at conversations, outdoor walks, noisy office, or waiting at terminals.
                </p>
                <p>
                    <b>Instant-away</b> Headphones can help people’s timely reactions to emergency, broadcasts, and greetings from others as if they disappear instantly
                </p>
                <div class='image-middle-container'>
                    <img src="https://miro.medium.com/max/1400/1*vYGEKKBGrisI9fYt6PWEvg.gif" width="100%">
                </div>
            </div>
            <div class="paragraph">
                <h4>SOLUTION</h4>
                <blockquote>
                    Empowering headphones with ambient awareness
                </blockquote>
            </div>
            <div class="paragraph">
                <div class='interview' >
                    <div class='left_p'>
                        <img src="https://miro.medium.com/max/1400/1*ltcM1L0NRbmev4Nj6Wrziw.png" width="90%">
                    </div>
                    <div class="right_p">
                        <h4>Seamless Conversation</h4>
                        <p>
                            Talk without taking off your headphones, and resume music with a single tap
                        </p>
                    </div>
                </div> 
            </div>
            <div class="paragraph">
                <div class='interview' >
                    <div class='left_p'>
                        <img src="https://miro.medium.com/max/1400/1*y2wa6INEdFmgSYD4qcc8wQ.png" width="90%">
                    </div>
                    <div class="right_p">
                        <h4>Just-enough Outside Sound</h4>
                        <p>
                            Talk without taking off your headphones, and resume music with a single tap
                        </p>
                    </div>
                </div> 
            </div>
            <div class="paragraph">
                <div class='interview' >
                    <div class='left_p'>
                        <img src="https://miro.medium.com/max/1400/1*AlAdvLu5eJbT9mph39FWWA.png" width="90%">
                    </div>
                    <div class="right_p">
                        <h4>Event Monitoring</h4>
                        <p>
                            Notify you when key sounds are detected so you will not miss important information
                        </p>
                    </div>
                </div> 
            </div>
            <div class="paragraph">
                <h4>Onboarding UX</h4>
                <div class='image-middle-container'>
                    <img src="https://miro.medium.com/max/1400/1*USAiEGuaQ6rDRlzw-cambA.gif" width="100%">
                </div>
            </div>
            <div class="paragraph">
                <h4>IMPLEMENTATION</h4>
                            <p>
                    An ML-powered real-time software solution which monitors, predicts, and reacts to surroundings, featuring:
                </p>
                <div class="paragraph">
                <h4>Acoustic Ambiance</h4>
                <p>Audio scenes — engine noise, babble noise<br>
                Audio events — keywords, sirens
                </p>
                </div>
                <div class="paragraph">
                <h4>Edge Computing</h4>
                <p>Real-time inference for CNN models with on-the-fly quantization on current hardware
                </p>
                </div>
                <div class="paragraph">
                <h4>Deep Integration</h4>
                <p>Music volume adjustment, voice pass-through, audio prompts on the headsets
                </p>
                </div>
                <div class='image-middle-container'>
                    <img src="https://miro.medium.com/max/1400/1*fSupECZbSxWj1VaQVVXJ9A.png" width="100%">
                    <figcaption>Solution Logic & Data Flow</figcaption>
                </div>
            </div>
            <div class="paragraph">
                <h4>IMPACT</h4>
                <p>100% of participants found the new feature useful. &#127775;<br>
                85% of participants would turn on the new feature; &#127765; <br>
                30% of participants would purchase JBL headset for the new feature. &#10024;
                </p>
                <p>Functional prototypes and toolchain were handed over to Harman to continue software implementation and integration.</p>
            </div>

            
        </div>

    </div>

    <div class="light-page">
        <div class="content-container">
            <div class="title">
                <div class = "title-color2"> </div>
                <div class="title-text">
                    <h4>PROCESS</h4>
                    <h5>&nbsp</h5>
                </div>
            </div>
        </div>
        <div class="content-container-large">
            <img src="https://miro.medium.com/max/1400/1*yMcZfXlS7rjSgN90HjEUpw.png" width='100%' class='large-img'>
        </div>
        <div class="content-container">
            <div class="paragraph">
                <h4>1 - USER RESEARCH</h4>
                <blockquote>
                    When & How are people using noise-canceling headphones?
                </blockquote>
                <br>
                <div class='image-middle-container'>
                    <img src="https://miro.medium.com/max/1400/1*QGziI4T0RaP6IWXN2zJ8iQ.png" width="100%">
                </div>
            <div class="paragraph">
                <h4>Persona</h4>
                <div class='image-middle-container'>
                    <img src="https://miro.medium.com/max/1400/1*i_CWPfOVRm8lf69lTK6P8Q.png" width="100%">
                </div>
            </div>
            </div>
        </div> 
        <div class="content-container">
            <div class="paragraph">
                <h4>Insights</h4>
                <div class='image-middle-container'>
                    <img src="https://miro.medium.com/max/1400/1*cG1SvJ0N7I8TvzLAUE9C8A.png" width="100%">
                </div>
                <blockquote>
                    People use ANC headphons to better achieve their primary tasks, with a compromise on their responsiveness
                </blockquote>
                <h4>Scenario & Event-Based Hearing Augmentation</h4>
                <p>
                    We can help users stay responsive while enjoying immersive music through headphones.
                </p>
                <div class='image-middle-container'>
                    <img src="https://miro.medium.com/max/1400/1*o0zQGL9g0RobY-AK6I6Ehw.png" width="100%">
                </div>
            </div>
            <br>
            <div class="paragraph">
                <br>
                <h4>2 - IDEATION</h4>
                <blockquote>
                   How can we design for an everyday product?
                <br>- Dive into everyday lives.
                </blockquote>  
                <br>
                <h4>Co-Design With User</h4>  
                <div class='image-middle-container'>
                    <img src="https://miro.medium.com/max/1400/1*zzMfEnaI4d4rYnNw7xGI8w.png" width="100%">
                </div>
                <p>
                    We co-created with ANC headset users to explore the just-right features for headphones and collected 80+ ideas.
                </p>
            </div>
        </div> 
        <br>  
        <div class='content-container-large'>
            <img src="https://miro.medium.com/max/1400/1*1nkTodcEi0yHoPpocdnNjQ.png" width="100%">
        </div>       
        <br>
        <div class="content-container">
            <div class="paragraph">
                <h4>Prioritize into MVP</h4>
                <p>The most compelling directions and value we can bring to the users:</p>
            </div>
        </div>
        <div class='content-container-large'>
            <img src="https://miro.medium.com/max/1400/1*aTA0URM0_ndCKjjB7OuUgw.png" width="100%">
        </div> 
        <br>
        <br>
        <br>
        <div class="content-container">
            <div class="paragraph">
                <h4>3 - EVALUATE & BUILD</h4> 
                 <blockquote>
                    Transform concept into functions through user evaluation
                </blockquote>
            </div>
            <div class="paragraph">
                <h4>Validate user needs through behavioral prototyping</h4> 
            </div>           
        </div>  
        <div class='content-container-large'>
            <img src="https://miro.medium.com/max/1400/1*Jta4IdqRVijwnRMIstAeKQ.png" width="100%">
            <figcaption>*Please read full case study for more details.*</figcaption>
        </div> 
        <div class="content-container">
            <div class="paragraph">
                <h4>Find the right default settings through user experiments</h4> 
                <div class='image-middle-container'>
                    <img src="https://miro.medium.com/max/1400/1*BlWVwfPK29-sjhhHAlt7Nw.png" width="100%">
                    <figcaption>*Please read full case study for more details.*</figcaption>
                </div>
            </div>
        </div>  
        <br>
        <br>
        <div class="content-container">
            <div class="paragraph">
                <h4>4 - DELIVER & ONBOARD</h4> 
                 <blockquote>
                    How might we communicate the features to users, and allow users to customize default settings during out-of-box setup?
                </blockquote>
            </div>
            <div class="paragraph">
                <h4>UI Iterations</h4>
                <p>
                    Due to technical limits, users would need to manually collect samples for customized key sounds.
                </p>
            </div> 
        </div>
        <!-- <div class='content-container-large'> -->
            <img src="/static/harmonica/Onboarding UX.png" width="100%">
        <!-- </div>          -->
        <div class="content-container">
                    <br><br>
            <div class="paragraph">
                <h4>5-SUMMARY</h4> 
            </div>
            <div class="paragraph">
                <h4>System Design</h4>
            </div>
        </div>
        <div class='content-container-large'>
            <img src="https://miro.medium.com/max/1400/1*E6Ldsljk1rX4ci72bV6i3A.png" width="100%">
        </div>
        <!-- <div class="content-container">
            <div class="paragraph">
                <h4>Trilogy of Launches</h4>                
            </div>
        </div>
        <div class='content-container-large'>
            <img src="/static/harmonica/GTM.png" width="100%">
        </div> -->
    </div>
    <br><br>
     <div class="light-page">
        <div class="content-container">
            <div class="title">
                <div class = "title-color2"> </div>
                <div class="title-text">
                    <h4>REFLECTIONS</h4>
                    <h5>&nbsp</h5>
                </div>
            </div>
        </div>
        <div class='content-container-large'>
            <img src="https://miro.medium.com/max/1400/1*TsO44Pt2PnKyN2T7BSKyNw.png" width="100%">
            <figcaption> the working demo to Harman & GIX Leadership Team </figcaption> 
        </div>
        <div class="content-container">
            <div class="paragraph">
                <h4>Trust your users.</h4>
                <p>
                    They have so many inspiring ideas. Whenever you feel at a loss, talk to a user.
                </p>
            </div>
            <div class="paragraph">
                <h4>Trust your teammates.</h4>
                <p>
                    Engineering and design mindset are both important when shaping a product .
                </p>
            </div>
            <div class="paragraph">
                <h4>Trust your process.</h4>
                <p>
                    Human-centered design methods can guide you to learn in a new field quickly.
                </p>
            </div>
            <div class=paragraph>
                <!-- <p>
                <a style="text-decoration: none;color: rgb(0, 0, 0);border-bottom:1px dashed rgb(160, 160, 160);" href="https://medium.com/@sixuanli/harmonica-92a53d343515" target="blank">
                Read Full Case Study
                </a>
                </p> -->
                <div class='button' onclick="window.open('https://medium.com/@sixuanli/harmonica-92a53d343515','_blank')" target="blank">Read Full Case Study</div>
            </div>
        </div>
    </div>


    <div class="light-page">
        <div class="content-container">
            <div class="ending-pointer">
                <div onclick="window.location.href='/#/camt'">
                    <span class="next">Next Project</span><br/>
                    <span class="project">A-Watch</span>
                </div>
            </div>
        </div>
    </div>
</div>
</div>
</template>


<script>
export default {
        created() {  
        var delayInMilliseconds = 800;
        setTimeout(function() {
            document.body.removeChild(document.getElementById('Loading'))   
        }, delayInMilliseconds); 
    },
}
</script>

<style>
.title{
    margin-top: 20px;
    margin-bottom: 0px;
    padding-left: 0px;
    vertical-align: left;
    display:flex;
}

.button{
    border:0;
    outline:none;
    border-radius:0;
    padding:15px 0;
    font-size:18px;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight:bold;
    text-align: center;
    /* text-transform:uppercase; */
    letter-spacing:.1em;
    background:#000000;
    color:#ffffff;
    transition:all.1s ease;
    -webkit-appearance: none;
    cursor:pointer;
}
.button:hover{
    background:#3c3c3c;
}


p{
    font-family: 'Source Sans Pro', sans-serif;
    margin:0 0 10px 0;
    line-height: 29px;
    font-size: 16px;
    letter-spacing: 0.05em;
    font-weight: 500;
    color: #000000;
    text-align:left;
    /* margin-bottom:5rem; */
}
h1{
    font-weight: bold;
    letter-spacing:0.1em;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 30px;
    line-height: 2.4rem;
    color: #202020;
    margin: 10px 0 0 0;
    text-align:left;
}
h2{
    font-weight: bold;
    letter-spacing:0.1em;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 20px;
    color: #202020;
    margin: 18px 0 11px 0;
    text-align:left;
}
h3{
    font-weight: bold;
    letter-spacing:0.1em;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 18px;
    color: #202020;
    line-height: 29px;
    text-align:left;
    /* text-transform: uppercase; */
    margin:0;
}
h4{
    font-weight:bolder;
    /* font-weight:1000; */
    letter-spacing:0.1em;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 24px;
    color:#000000;
    text-align:left;
    margin-top:0rem;
    margin-bottom:1rem;

}

h6{
    font-weight: bold;
    letter-spacing:1px;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 22px;
    color: #9d9d9d;
    margin: 12px 0 20px 0;
    text-align:left;

}
.paragraph{
    margin-top:2rem;
    margin-bottom:2rem;
}

p.video{
    margin: 30px 0 80px;
    text-align: center;
}
.quote{
    position: relative;
    border-left: dashed #9d9d9d 1px;
    margin: 20px;
    margin-right: 0;
    margin-left: 25px;
    padding-left: 8px;
    /* margin-bottom:20px; */
    /* font-style: italic; */
}

.quote>p>b.yellow{
    color: #F3D884;
}
.quote>p>b.orange{
    color: #F2994A;
}
.interview{
    display: flex;
    margin-top:4rem;
}
.interview2{
    display: flex;
}
.right_p{
    flex:1;
    margin-left: 3rem;
    }
.right_p2{
    flex:1;
    }
.left_p2{
    flex: 0 0 7rem;
}
.left_p{
    flex: 0 0 300px;
}
img{
    /* margin: 0px 0 5px 0; */
}
.image-middle-container{
    margin: 40px auto;
}
.large-img{
    margin:3rem 0 3rem 0;
}
.table-3>tbody>tr>td{
    padding: 20px 30px;
    font-family: 'Source Sans Pro', sans-serif;
    font-style: normal;
    font-weight: normal;
    line-height: 29px;
    font-size: 15px;
    letter-spacing: 0.04em;
    border: 0;
    vertical-align: top;
}

.table-3>tbody>tr>td>h3{
    margin: 0;
}

.table-3-left{
    width: 35%;
}
.table>tbody>tr>td, .table>tbody>tr>th{
    border: solid #ffffff 2px;
    padding: 10px;
    vertical-align: middle;
    font-family: 'Source Sans Pro', sans-serif;
    line-height: 27px;
    font-size: 15px;
    letter-spacing: 0.04em;
}

.table>tbody>tr>td{
    text-align: left;
}

.table>tbody>tr>th{
    text-align: center;
}

h3.black{
    font-family: 'Source Sans Pro', sans-serif;
    font-style: normal;
    font-weight: bold;
    line-height: 29px;
    font-size: 15px;
    letter-spacing: 0.04em;
    color: #000000;
}

h3.gray{
    font-family: 'Source Sans Pro', sans-serif;
    font-style: normal;
    font-weight: normal;
    line-height: 29px;
    font-size: 15px;
    letter-spacing: 0.04em;

    color: #9d9d9d;
}

td.dark-td{
    background-color: #f2f2f2; ;
    padding:15px 20px;
}

td.light-td{
    background-color: #ffffff; ;
    padding:15px 20px;
}
.dark-dark-page{
    position: relative;
    background-color: #E0E0E0;
    padding: 20px 20px 60px;
}
.text-image{
    width:86%;
    margin:40px auto;
}
.findings{
    margin:20px auto;
}

.interview{
    margin:0;
}
</style>



// WEBPACK FOOTER //
// src/components/harmonica.vue